import React, { Component } from 'react'
import ReactPasswordStrength from 'react-password-strength'
import { firebaseApp } from '../../../../config'
import { browserHistory } from 'react-router'
import './Login.scss'

class HomeLogin extends Component {

    constructor(props) {
        super(props)
        this.state = {
          reset: false
        }
        this._login = this._login.bind(this)
        this._register = this._register.bind(this)
        this._changeForm = this._changeForm.bind(this)
        this._validateEmail = this._validateEmail.bind(this)

        this._resetPassword = this._resetPassword.bind(this)

    }

   _login (e) {
     e.preventDefault()
    const {email_login, password_login} = this.state
    firebaseApp.auth().signInWithEmailAndPassword(email_login, password_login).then(() => {
     // this.setState({reset: !this.state.reset})
     // this.props.notify("Please check your email, we've sent you a reset link", 500, 'success')
    }).catch((error) => {
      if (error) this.props.notify(error.message, 5, 'error')
    })

   }

   _register (e) {
     e.preventDefault()
    const {password_confirm} = this.state
    const email = this.refs.email.value
    firebaseApp.auth().createUserWithEmailAndPassword(email, password_confirm).catch((error) => {
      if (error) {
        this.props.notify(error.message, 5, 'error')
      } else {
        firebase.auth().signInWithEmailAndPassword(email, password_confirm)
      }
    })

   }

   _changeForm (key, value) {
      this.setState({[key]: value})
   }

   _resetPassword (type) {
     if (type === 'send') {
      firebaseApp.auth().sendPasswordResetEmail(this.refs.reset_email.value).then(() => {
       this.setState({reset: !this.state.reset})
       this.props.notify("Please check your email, we've sent you a reset link", 500, 'success')
      }).catch((error) => {
        if (error) return this.props.notify(error.message, 5, 'error')
      })
     } else {
       this.setState({reset: !this.state.reset})
     }
   }

   _validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    render() {
        return (
            <div className='login pad'>

               <div className="">

                <div className='container'>

                <div className='row'>

                  {this.props.location === 'login' &&

                    <div className='col-sm-6'>

                      <div className="main-login main-center">
                        <h2>Login</h2>
                        <h5>Sign up once and watch any of our free demos.</h5>
                        {!this.state.reset &&
                          <form className="" onSubmit={(e) => this._login(e)}>


                            <div className="form-group">
                              <label for="email" className="cols-sm-2 control-label">Your Email</label>
                              <div className="cols-sm-10">
                                <input type="text" className="form-control" name="email" id="email"  placeholder="Enter your Email" onChange={(e) => this._changeForm('email_login', e.target.value)}/>
                              </div>
                            </div>

                            <div className="form-group">
                              <label for="confirm" className="cols-sm-2 control-label">Confirm Password</label>
                              <div className="cols-sm-10">
                                <input type="password" className="form-control" name="confirm" id="confirm"  placeholder="Enter your Password" onChange={(e) => this._changeForm('password_login', e.target.value)}/>
                              </div>
                            </div>

                            <div className="form-group ">
                              <div className='row'>
                                <div className='col-sm-8'>
                                  <a onClick={() => this._resetPassword('sadfasd')}>Forgotten password?</a>
                                </div>
                                <div className='col-sm-4'>
                                  <button href="https://ccp.cloudaccess.net/aff.php?aff=5188" type="submit" id="button" className="btn btn-success btn-lg btn-block login-button">Login</button>
                                </div>
                              </div>
                            </div>

                          </form>
                        }

                        {this.state.reset &&
                          <div className='row'>
                          <br/>
                            <div className='col-sm-8'>
                              <div className="form-group">
                                <label for="email" className="cols-sm-2 control-label">Get Password Reset Link</label>
                                <div className="cols-sm-10">
                                  <input type="text" ref='reset_email' className="form-control" name="email" id="email"  placeholder="Enter your Email" onChange={(e) => this._changeForm('email_reset', e.target.value)}/>
                                </div>
                              </div>
                            </div>


                            <div className='col-sm-4'>
                              <label>&nbsp;</label>
                              <button href="https://ccp.cloudaccess.net/aff.php?aff=5188" onClick={() => this._resetPassword('send')} type="submit" id="button" className="btn btn-success btn btn-block login-button">Send</button>
                            </div>

                            <div className='col-sm-6'>
                              <a onClick={() => this._resetPassword('sadfasd')}>Cancel</a>
                            </div>

                          </div>
                        }

                      </div>

                    </div>
                  }
                  {this.props.location === 'register' &&
                    <div className='col-sm-6'>
                      <div className="main-login main-center">
                        <h2>Register</h2>
                        <h5>Sign up once and watch any of our free demos.</h5>
                        <form className="" autocomplete="false" onSubmit={(e) => this._register(e)}>



                          <div className="form-group">
                            <label for="email" className="cols-sm-2 control-label">Your Email Address</label>
                            <div className="cols-sm-10">
                              <input autocomplete="false" ref='email' type="text" className="form-control" name="email" id="email"  placeholder="Enter your Email" onChange={(e) => this._changeForm('email', e.target.value)}/>
                            </div>
                          </div>



                          <div className="form-group">
                            <label for="password" className="cols-sm-2 control-label">Password</label>
                            <div className="cols-sm-10">

                              <ReactPasswordStrength
                                className=""
                                minLength={5}
                                minScore={2}
                                scoreWords={['weak', 'okay', 'good', 'strong', 'stronger']}
                                changeCallback={(e) => this._changeForm('password', e)}
                                inputProps={{ name: "password_input", placeholder: 'Enter your Password', autoComplete: "off", className: "form-control" }}
                              />

                            </div>
                          </div>

                            <div className="form-group">
                              <label for="confirm" className="cols-sm-2 control-label">Confirm Password</label>
                              <div className="cols-sm-10">
                                <input disabled={!this.state.password || !this.state.password.password || !this.state.password.isValid} type="password" className="form-control" name="confirm" id="confirm"  placeholder="Confirm your Password" onChange={(e) => this._changeForm('password_confirm', e.target.value)}/>
                              </div>
                            </div>



                          <div className="form-group ">

                            <div className='row'>
                              <div className='col-sm-4 pull-right'>
                                <button disabled={!this.state.password || this.state.password.password !== this.state.password_confirm || !this._validateEmail(this.refs.email.value)} href="https://ccp.cloudaccess.net/aff.php?aff=5188" type="submit" id="button" className="btn btn-success btn-lg btn-block pull-right login-button">Register</button>
                              </div>
                            </div>

                          </div>

                        </form>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        )
    }
}

export default HomeLogin



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeLogin/index.js